import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';

import asyncComponent from '../../../../../util/asyncComponent';


const ITSupport = ({match}) => (
    <div className="app-wrapper">
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/user`}/>
            <Route path={`${match.url}/user`} component={asyncComponent(() => import('./routes/User'))}/>
            <Route path={`${match.url}/department`} component={asyncComponent(() => import('./routes/Department'))}/>
            <Route path={`${match.url}/trip`} component={asyncComponent(() => import('./routes/Trip'))}/>
            <Route path={`${match.url}/pack`} component={asyncComponent(() => import('./routes/Pack'))}/>
            <Route path={`${match.url}/employee`} component={asyncComponent(() => import('./routes/Employee'))}/>
            <Route path={`${match.url}/pool-group`} component={asyncComponent(() => import('./routes/PoolGroup'))}/>
            <Route path={`${match.url}/geofence`} component={asyncComponent(() => import('./routes/Geofence'))}/>
            <Route path={`${match.url}/lead-time`} component={asyncComponent(() => import('./routes/LeadCustomer'))}/>
            <Route component={asyncComponent(() => import('components/Error404'))}/>
        </Switch>
    </div>
);

export default ITSupport;


// WEBPACK FOOTER //
// ./app/routes/MasterData/routes/ITSupport/index.js